import * as Monitaro from '@/infrastructure/network/Monitaro/schema/models'
import { APIRequest } from '@/infrastructure/network/APIRequest'
import { HTTPMethod } from '@/infrastructure/network/types'

/**
 * 出入り時刻一覧
 *
 * 出入り時刻の一覧を返す
 */
export class FetchAdmission implements APIRequest<Monitaro.FetchAdmissionResponse> {
  response: Monitaro.FetchAdmissionResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.GET
  params?: Monitaro.Query
  constructor(query?: Monitaro.Query) {
    this.params = query
    this.path = `/admissions`
  }
}

/**
 * 出入り時刻の修正
 *
 * 指定された出入り時刻の修正
 */
export class PutAdmission implements APIRequest<Monitaro.PutAdmissionResponse> {
  response: Monitaro.PutAdmissionResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.PUT
  params: Monitaro.AdmissionRequest
  constructor(admission: string, params: Monitaro.AdmissionRequest) {
    this.params = params
    this.path = `/admissions/${admission}`
  }
}
